/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyStoriesLatest
 */
export interface CompanyStoriesLatest {
    /**
     * 
     * @type {number}
     * @memberof CompanyStoriesLatest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyStoriesLatest
     */
    hash: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyStoriesLatest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyStoriesLatest
     */
    smallThumbnailUrl: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyStoriesLatest
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyStoriesLatest
     */
    postedAt: string;
}

export function CompanyStoriesLatestFromJSON(json: any): CompanyStoriesLatest {
    return CompanyStoriesLatestFromJSONTyped(json, false);
}

export function CompanyStoriesLatestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyStoriesLatest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'hash': json['hash'],
        'title': json['title'],
        'smallThumbnailUrl': json['small_thumbnail_url'],
        'tags': json['tags'],
        'postedAt': json['posted_at'],
    };
}

export function CompanyStoriesLatestToJSON(value?: CompanyStoriesLatest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'hash': value.hash,
        'title': value.title,
        'small_thumbnail_url': value.smallThumbnailUrl,
        'tags': value.tags,
        'posted_at': value.postedAt,
    };
}

